import cn from 'classnames'
import React, { ComponentProps } from 'react'

type ReceiptUploadIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ReceiptUploadIcon(props: ReceiptUploadIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ReceiptUploadIcon', className)}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33331 7.49992C7.87308 7.49992 7.49998 7.87301 7.49998 8.33325V13.3333C7.49998 13.7935 7.12688 14.1666 6.66665 14.1666C6.20641 14.1666 5.83331 13.7935 5.83331 13.3333V8.33325C5.83331 6.95254 6.9526 5.83325 8.33331 5.83325H13.3333C13.7936 5.83325 14.1666 6.20635 14.1666 6.66659C14.1666 7.12682 13.7936 7.49992 13.3333 7.49992H8.33331Z"
        fill="#4489F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5 8.33325C32.5 7.87301 32.1269 7.49992 31.6667 7.49992L26.6667 7.49992C26.2064 7.49992 25.8334 7.12682 25.8334 6.66658C25.8334 6.20635 26.2064 5.83325 26.6667 5.83325L31.6667 5.83325C33.0474 5.83325 34.1667 6.95254 34.1667 8.33325L34.1667 13.3333C34.1667 13.7935 33.7936 14.1666 33.3334 14.1666C32.8731 14.1666 32.5 13.7935 32.5 13.3333L32.5 8.33325Z"
        fill="#4489F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6667 32.5001C32.1269 32.5001 32.5 32.127 32.5 31.6667L32.5 26.6667C32.5 26.2065 32.8731 25.8334 33.3334 25.8334C33.7936 25.8334 34.1667 26.2065 34.1667 26.6667L34.1667 31.6667C34.1667 33.0475 33.0474 34.1667 31.6667 34.1667L26.6667 34.1667C26.2064 34.1667 25.8334 33.7937 25.8334 33.3334C25.8334 32.8732 26.2064 32.5001 26.6667 32.5001L31.6667 32.5001Z"
        fill="#4489F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49998 31.6667C7.49998 32.127 7.87308 32.5001 8.33331 32.5001L13.3333 32.5001C13.7936 32.5001 14.1666 32.8732 14.1666 33.3334C14.1666 33.7937 13.7936 34.1667 13.3333 34.1667L8.33331 34.1667C6.9526 34.1667 5.83331 33.0475 5.83331 31.6667L5.83331 26.6667C5.83331 26.2065 6.20641 25.8334 6.66665 25.8334C7.12688 25.8334 7.49998 26.2065 7.49998 26.6667L7.49998 31.6667Z"
        fill="#4489F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9878 14.1667C14.9038 14.1667 14.8357 14.2348 14.8357 14.3188V26.2113L16.4913 24.6832C16.8697 24.3338 17.4421 24.3004 17.8586 24.6033L19.8909 26.0813L21.7225 24.616C22.0784 24.3313 22.5747 24.3007 22.9629 24.5395L24.7478 25.6379V14.3188C24.7478 14.2348 24.6797 14.1667 24.5957 14.1667H14.9878ZM13.1691 14.3188C13.1691 13.3143 13.9834 12.5 14.9878 12.5H24.5957C25.6002 12.5 26.4144 13.3143 26.4144 14.3188V26.6884C26.4144 27.2847 25.931 27.7681 25.3347 27.7681C25.135 27.7681 24.9391 27.7126 24.7689 27.6079L22.4412 26.1754L20.5823 27.6625C20.2024 27.9664 19.6662 27.9788 19.2728 27.6926L17.2678 26.2345L14.9811 28.3453C14.5429 28.7498 13.8598 28.7225 13.4554 28.2843C13.2713 28.0849 13.1691 27.8234 13.1691 27.552V14.3188Z"
        fill="#4489F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1253 20.0001C16.1253 19.5398 16.4984 19.1667 16.9586 19.1667H20.292C20.7522 19.1667 21.1253 19.5398 21.1253 20.0001C21.1253 20.4603 20.7522 20.8334 20.292 20.8334H16.9586C16.4984 20.8334 16.1253 20.4603 16.1253 20.0001Z"
        fill="#4489F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1253 16.7774C16.1253 16.3172 16.4984 15.9441 16.9586 15.9441H21.9586C22.4189 15.9441 22.792 16.3172 22.792 16.7774C22.792 17.2377 22.4189 17.6108 21.9586 17.6108H16.9586C16.4984 17.6108 16.1253 17.2377 16.1253 16.7774Z"
        fill="#4489F9"
      />
    </svg>
  )
}
